import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import configStore, { ConfigContext } from "./networkConfigStore";
import { requestSourceProxyConfig } from "./msgs/sourceProxyMsgSender";
import { requestGetDHCPD, requestGetNICS, requestListConnections } from "./msgs/networkConfigMsgSender";
import { requestCheckDhcpPackageStatus } from "./msgs/dhcpPackageStatusCaller";

interface IProps {
    appID?: string;
    children: ReactNode;
}

function NetworkConfigProvider(props: IProps) {
    useEffect(() => {
        requestSourceProxyConfig();
        requestGetDHCPD();
        requestGetNICS();
        requestListConnections();
        requestCheckDhcpPackageStatus();
    }, []);
    return (
        <Provider store={configStore} context={ConfigContext}>
            {props.children}
        </Provider>
    );
}

export default NetworkConfigProvider;
